import { MapTo } from '@adobe/aem-react-editable-components';
import { withTranslation } from '@yme/services/i18n';
import { AEM_FUNCTIONS } from '../../common';
import Footer from './Footer';
export default MapTo(AEM_FUNCTIONS.footerMenu)(withTranslation(Footer, ['newsletter.labels']));
